import styled from '@emotion/styled';

export const HeroImage = styled.img`
  height: 250px;
  margin: auto;
`;

export const Content = styled.div`
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  grid-area: body;
`;
